<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="m21.948 10.078-5.915 9.276c-.118.182-.39.064-.345-.145l1.572-6.85h-2.217a.38.38 0 0 1-.373-.464l1.672-7.304A.757.757 0 0 1 17.078 4h4.46c.3 0 .482.327.319.581l-3.135 4.916h2.898c.3 0 .482.327.319.581h.009ZM12.726 10.514l-4.361 6.832c-.082.128-.29.046-.254-.109l1.153-5.042H7.63a.277.277 0 0 1-.273-.336L8.592 6.48a.555.555 0 0 1 .545-.436h3.29c.217 0 .353.246.235.427l-2.307 3.616h2.135c.218 0 .354.245.236.427ZM5.44 10.941 2.64 15.33c-.054.082-.181.028-.163-.063l.745-3.244H2.178c-.118 0-.2-.109-.173-.218l.79-3.452a.358.358 0 0 1 .346-.282h2.108c.145 0 .227.155.154.273l-1.48 2.326h1.371c.146 0 .227.154.155.272h-.01Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
